import moment from "moment";
moment.locale("zh-cn");

/**
 * 时间格式转换
 * @param time
 * @param dateFormat
 */
export function getTime(time, dateFormat = "YYYY-MM-DD HH:mm:ss") {
  if (
    new Date(time).getTime() === 0 ||
    time === "1970-01-01T08:00:01+08:00" ||
    time === "0001-01-01T00:00:00Z"
  ) {
    return "";
  }
  return moment(time).format(dateFormat);
}

/**
 * utc时间格式转换
 * @param time
 * @param dateFormat
 */
export function getUtcTime(time, dateFormat = "YYYY-MM-DD HH:mm:ss") {
  if (
    new Date(time).getTime() === 0 ||
    time === "1970-01-01T08:00:01+08:00" ||
    time === "0001-01-01T00:00:00Z"
  ) {
    return "";
  }
  return moment(time).utc().format(dateFormat);
}

/**
 * 获取当前时间
 * @param {*} format 
 * @returns 
 */
export function getCurrentFormattedDate(format = "YYYY-MM-DD hh:mm:ss") {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  const formattedDate = format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('hh', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);

  return formattedDate;
}